import styled from 'styled-components';

const LabelModalStyled = styled.div`
  /* min-height: 516px; */
  .label-list-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /* gap:36px; */
    padding: 8px;
    max-width: 820px;
    .label-content:nth-of-type(2n-1) {
      margin-right: 18px;
    }
    .label-content:nth-of-type(2n) {
      margin-left: 18px;
      margin-right: 0;
    }
    .label-content {
      border-radius: 4px;
      display: flex;
      flex-direction: row;
      padding: 20px 22px 20px 24px;
      gap: 24px;
      border: 1px solid #cccccc;
      align-items: center;
      margin: 0 0 16px 0;
      cursor: pointer;
      img {
        width: 108px;
      }
      .label-title-wrap {
        display: flex;
        flex-direction: column;
        width: 144px;
        gap: 8px;
        .label-title {
          font-size: 16px;
          font-weight: 400;
          color: #212121;
          line-height: 22px;
        }
        .label-title-content {
          font-size: 12px;
          font-weight: 400;
          color: #616161;
          line-height: 17px;
        }
      }
    }
    .isChosen {
      border: 1px solid #1565c0;
    }
  }
  .MuiFormControlLabel-root {
    margin-right: 0 !important;
  }
  .label-btn-wrap {
    display: flex;
    flex-direction: row;
    float: right;
    margin: 30px 8px 32px 0;
    gap: 16px;
  }
`;

export default LabelModalStyled;
